import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { v4 as uuidv4 } from 'uuid'

(function() {
	'use strict'

    let markers = {}

    document.addEventListener( 'DOMContentLoaded', () => {
        document.querySelectorAll( '.module-location-map #map' )?.forEach( ( item ) => {
            let map = L.map('map').setView([ item.getAttribute('data-lat'), item.getAttribute('data-lng')], item.getAttribute('data-zoom')),
                locations = JSON.parse(item.getAttribute('data-locations'))

            L.NumberedDivIcon = L.Icon.extend({
                options: {
                    iconUrl: "data:image/svg+xml," + encodeURIComponent('<svg id="Ebene_2" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 564.11 797.12"><g id="Ebene_2-2" data-name="Ebene 2"><g><path id="Layer_7" data-name="Layer 7" d="M282.94,797.12l-21.33-26.4C209.71,707.31.27,421.07.27,282.19-6.36,133.12,109.12,6.9,258.19.27c7.89-.36,15.8-.36,23.73,0,149.07-6.63,275.29,108.85,281.92,257.92.36,8,.36,16,0,24,0,118.03-142.35,325.92-249.49,472.05l-31.41,42.88Z" style="fill: #fff;"/><path id="Layer_7-2" data-name="Layer 7" d="M282.94,797.12l-21.33-26.4C209.71,707.31.27,421.07.27,282.19-6.36,133.12,109.12,6.9,258.19.27c7.89-.36,15.8-.36,23.73,0,149.07-6.63,275.29,108.85,281.92,257.92.36,8,.36,16,0,24,0,118.03-142.35,325.92-249.49,472.05l-31.41,42.88ZM281.92,52.86c-119.9-6.76-222.57,84.96-229.33,204.86-.46,8.15-.46,16.32,0,24.48,0,97.71,147.15,322.03,228.59,428.48,66.67-91.2,230.13-319.41,230.13-428.48,6.76-119.9-84.96-222.57-204.86-229.33-8.15-.46-16.32-.46-24.48,0h-.05Z"/></g></g></svg>'),
                    number: '',
                    shadowUrl: null,
                    iconSize: new L.Point(25, 34),
                    iconAnchor: new L.Point(13, 34),
                    popupAnchor: new L.Point(0, -33),
                    /*
                    iconAnchor: (Point)
                    popupAnchor: (Point)
                    */
                    className: 'leaflet-div-icon'
                },

                createIcon: function () {
                    var div = document.createElement('div');
                    var img = this._createImg(this.options['iconUrl']);
                    var numdiv = document.createElement('div');
                    numdiv.setAttribute ( "class", "number" );
                    numdiv.innerHTML = this.options['number'] || '';
                    div.appendChild ( img );
                    div.appendChild ( numdiv );
                    this._setIconStyles(div, 'icon');
                    return div;
                },

                //you could change this to add a shadow like in the normal marker if you really wanted
                createShadow: function () {
                    return null;
                }
            })

            L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            }).addTo(map)

            Object.keys(locations).forEach( ( key ) => {
                let marker_id = uuidv4(),
                    marker_content = "<b>"+locations[key]['title']+"</b><br/>"+locations[key]['street']+"<br/>"+locations[key]['postcode']+" "+locations[key]['city']+" "

                if ( locations[key]['url'] != '') {
                    marker_content += '<br/b><a href="'+locations[key]['url']+'" target="_blank">'+locations[key]['url']+'</a>'
                }
                    
                markers[marker_id] = new L.Marker(new L.LatLng(locations[key]['latitude'], locations[key]['longitude']), {
                    icon: new L.NumberedDivIcon({number: locations[key]['count']})
                }).addTo(map)
                //markers[marker_id] = L.marker([locations[key]['latitude'], locations[key]['longitude']]).addTo(map)
                markers[marker_id].bindPopup( marker_content )
            })
        })
    })
})( )